import React from 'react';
import PdfEditor from './PDFEditor';
import Modal from "react-bootstrap/Modal";
import PropTypes from 'prop-types';
/* istanbul ignore next */
const PdfEditorPopup = (props) => {
    const { handleCancel, showPopUp, handleUploadPdfAction } = props;
    return (
        <Modal
            {...props}
            size="xl"
            className="topUpModal productskuListing"
            centered
            backdrop="static"
            show={showPopUp}
            onHide={handleCancel}
        >
            <div className="top_modal_header_container no_mrg mb-0">
                <span className="">Upload Label</span>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleCancel()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <div className="productList">
                <PdfEditor isPopup={true} handleUploadPdfAction={handleUploadPdfAction} />
            </div>
        </Modal>
    );
}

PdfEditorPopup.propTypes = {
    handleCancel: PropTypes.func.isRequired,
    showPopUp: PropTypes.bool.isRequired,
    handleUploadPdfAction: PropTypes.func
};

export default PdfEditorPopup;